import {
  BlankSlate,
  BlankSlateDescription,
  BlankSlateIcon,
  BlankSlateTitle,
  Box,
  FileDropZone,
} from "@prismicio/editor-ui"
import type { ReactNode } from "react"

import { textConstants } from "../constants/text"
import { useMediaLibrary } from "./MediaLibraryContext"

interface MediaLibraryDropzoneProps {
  children: ReactNode
}

export function MediaLibraryDropzone(props: MediaLibraryDropzoneProps) {
  const { children } = props
  const { onFilesUpload, assetType } = useMediaLibrary()

  return (
    <FileDropZone
      overlay={<DropZoneOverlay />}
      onFilesSelected={onFilesUpload}
      assetType={assetType}
    >
      {children}
    </FileDropZone>
  )
}

function DropZoneOverlay() {
  const { isUploading } = useMediaLibrary()

  const title = isUploading
    ? textConstants.warning.uploadWhileUploading.title
    : "Drop files here"
  const description = isUploading
    ? textConstants.warning.uploadWhileUploading.description
    : "Drop your files to upload them instantly to the media library."

  return (
    <Box justifyContent="center" flexDirection="column" height="100%">
      <BlankSlate>
        <BlankSlateIcon
          name={isUploading ? "block" : "cloudUpload"}
          lineColor={isUploading ? "tomato11" : "purple10"}
          backgroundColor={isUploading ? "tomato2" : "purple3"}
          borderColor={isUploading ? "tomato6" : "purple6"}
          borderStyle="dashed"
          size="xlarge"
        />
        <BlankSlateTitle size="big">{title}</BlankSlateTitle>
        <BlankSlateDescription width={360}>{description}</BlankSlateDescription>
      </BlankSlate>
    </Box>
  )
}
